/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const contentTypeSnippets = {
    /**
     * Carousel Config
     */
    carousel_config: {
        codename: 'carousel_config',
        id: '67c0a708-2d02-42ef-8b73-8816fc78cf69',
        externalId: undefined,
        name: 'Carousel Config',
        elements: {
            /**
             * Mobile  Tiles to show (number)
             *
             * Recommended setting as per design: 1
             */
            carousel_config__slides_to_show_mobile: {
                codename: 'carousel_config__slides_to_show_mobile',
                id: 'eedc486d-172e-4e3e-96e5-8b16f7516f49',
                externalId: undefined,
                name: 'Mobile: Tiles to show',
                required: true,
                type: 'number'
            },

            /**
             * Mobile  Tiles to slide (number)
             */
            carousel_config__slide_to_scroll_mobile: {
                codename: 'carousel_config__slide_to_scroll_mobile',
                id: 'd471f851-b0fa-4f7f-88a3-111bac5b9e13',
                externalId: undefined,
                name: 'Mobile: Tiles to slide',
                required: true,
                type: 'number'
            },

            /**
             * Desktop  Tiles to show (number)
             */
            carousel_config__slides_to_show_desktop: {
                codename: 'carousel_config__slides_to_show_desktop',
                id: '004a406f-626a-46f6-bafe-a176ea0b95e2',
                externalId: undefined,
                name: 'Desktop: Tiles to show',
                required: true,
                type: 'number'
            },

            /**
             * Desktop  Tiles to slide (number)
             */
            carousel_config__slides_to_scroll_desktop: {
                codename: 'carousel_config__slides_to_scroll_desktop',
                id: '4324334a-0b95-4798-813b-7059a07a44f9',
                externalId: undefined,
                name: 'Desktop: Tiles to slide',
                required: true,
                type: 'number'
            },

            /**
             * Enable Autoplay (multiple_choice)
             *
             * Default value is "No"
             */
            carousel_config__autoplay: {
                codename: 'carousel_config__autoplay',
                id: 'e3eb6381-d988-4410-8f41-cd57511caa1b',
                externalId: undefined,
                name: 'Enable Autoplay',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * Autoplay  timeout (number)
             *
             * If enabled: Set how much time the slide will auto play (in seconds) until it stops completely.
             */
            carousel_config__autoplay_timeout: {
                codename: 'carousel_config__autoplay_timeout',
                id: '8ca5dd11-0de0-4865-97aa-3c479902854b',
                externalId: undefined,
                name: 'Autoplay: timeout',
                required: false,
                type: 'number'
            },

            /**
             * Autoplay  timer (number)
             */
            carousel_config__autoplay_timer: {
                codename: 'carousel_config__autoplay_timer',
                id: '9cf78efd-0ef0-4ca7-bfda-e07e9b3301ee',
                externalId: undefined,
                name: 'Autoplay: timer',
                required: false,
                type: 'number'
            },

            /**
             * Enable Loop (multiple_choice)
             *
             * Default value is "No". If set to "Yes", the carousel will not stop when it reaches the last tile. It will be an infinite loop.
             */
            carousel_config__infinite_loop: {
                codename: 'carousel_config__infinite_loop',
                id: '610004e0-bb2d-4b05-b927-3571990e3fe7',
                externalId: undefined,
                name: 'Enable Loop',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * Enable Arrows (multiple_choice)
             */
            carousel_config__enable_arrows: {
                codename: 'carousel_config__enable_arrows',
                id: '58173a02-7497-4dcf-ae3a-b4fff1eb5055',
                externalId: undefined,
                name: 'Enable Arrows',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * Arrows  transparent background (multiple_choice)
             *
             * Default state is "No". If set to "Yes", the arrows will not have the grey circle container around them.
             */
            carousel_config__arrows__transparent_background: {
                codename: 'carousel_config__arrows__transparent_background',
                id: '055b1a91-4de8-41f7-a3d4-0b5f457badcb',
                externalId: undefined,
                name: 'Arrows: transparent background',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * Arrows  color (modular_content)
             */
            carousel_config__slider_arrows_color: {
                codename: 'carousel_config__slider_arrows_color',
                id: '1cef893a-158b-49f2-859d-636d68812811',
                externalId: undefined,
                name: 'Arrows: color',
                required: false,
                type: 'modular_content'
            },

            /**
             * Arrows  size (multiple_choice)
             */
            carousel_config__slider_arrows_size: {
                codename: 'carousel_config__slider_arrows_size',
                id: '24095239-b83b-45be-94b7-49be2659708f',
                externalId: undefined,
                name: 'Arrows: size',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * Slider Width (multiple_choice)
             *
             * If "Full width" selected: the carousel will take the parent's container width.If "None" selected: the carousel will be inside it's own container but the tiles will "break" out on the right side.
             */
            carousel_config__slider_width: {
                codename: 'carousel_config__slider_width',
                id: '0c664156-c411-4d27-a152-efcb45262348',
                externalId: undefined,
                name: 'Slider Width',
                required: false,
                type: 'multiple_choice'
            }
        }
    },

    /**
     * Default Table Sorting
     */
    default_table_sorting: {
        codename: 'default_table_sorting',
        id: 'fe921272-c0e7-4953-8c0c-8d5e0a286d68',
        externalId: undefined,
        name: 'Default Table Sorting',
        elements: {
            /**
             * Default Sort Column (modular_content)
             */
            default_table_sorting__default_sort_column: {
                codename: 'default_table_sorting__default_sort_column',
                id: '2b3022c2-be38-4515-b22d-1605539b563f',
                externalId: undefined,
                name: 'Default Sort Column',
                required: false,
                type: 'modular_content'
            },

            /**
             * Default Sort Direction (multiple_choice)
             */
            default_table_sorting__default_sort_direction: {
                codename: 'default_table_sorting__default_sort_direction',
                id: '6ff0ed4c-7ba1-4690-a288-9fcb13d5ac7f',
                externalId: undefined,
                name: 'Default Sort Direction',
                required: false,
                type: 'multiple_choice'
            }
        }
    },

    /**
     * Form CTA Action Types
     */
    form_cta_action_types: {
        codename: 'form_cta_action_types',
        id: 'ec2c0df3-302b-4f69-897b-45e74a5d767d',
        externalId: undefined,
        name: 'Form CTA Action Types',
        elements: {
            /**
             * Action Type (multiple_choice)
             */
            form_cta_action_types__action_type: {
                codename: 'form_cta_action_types__action_type',
                id: 'b5d5db59-656c-42e5-b2eb-ff4420c057e2',
                externalId: undefined,
                name: 'Action Type',
                required: true,
                type: 'multiple_choice'
            }
        }
    },

    /**
     * Kontent Collections
     */
    kontent_collections: {
        codename: 'kontent_collections',
        id: 'c7e2f4a4-bbd3-4dea-9b70-fc4d6b26b87f',
        externalId: undefined,
        name: 'Kontent Collections',
        elements: {
            /**
             * Associated Kontent Collection (multiple_choice)
             */
            kontent_collections__associated_kontent_collection: {
                codename: 'kontent_collections__associated_kontent_collection',
                id: '536ba7f3-f346-4fc4-b1fc-ee0a2f4668be',
                externalId: undefined,
                name: 'Associated Kontent Collection',
                required: false,
                type: 'multiple_choice'
            }
        }
    },

    /**
     * SEO
     */
    seo: {
        codename: 'seo',
        id: '40e0d55c-22f7-45f5-99a6-8a52ebccd4a2',
        externalId: undefined,
        name: 'SEO',
        elements: {
            /**
             * Meta Title (text)
             */
            seo__meta_title: {
                codename: 'seo__meta_title',
                id: 'f3ef17b6-0bd4-4c1f-8e16-79d66bcb6f1f',
                externalId: undefined,
                name: 'Meta Title',
                required: true,
                type: 'text'
            },

            /**
             * Meta Description (text)
             */
            seo__meta_description: {
                codename: 'seo__meta_description',
                id: '69b9ad12-66e7-4b64-92ef-389ba8cb33d8',
                externalId: undefined,
                name: 'Meta Description',
                required: false,
                type: 'text'
            },

            /**
             * Keywords (text)
             */
            seo__key_words: {
                codename: 'seo__key_words',
                id: 'd5406280-ee99-459f-bebd-2f3794765acd',
                externalId: undefined,
                name: 'Keywords',
                required: false,
                type: 'text'
            },

            /**
             * No Index (multiple_choice)
             */
            seo__no_index: {
                codename: 'seo__no_index',
                id: '298ecfd0-51b9-4680-bb29-bb722456d928',
                externalId: undefined,
                name: 'No Index',
                required: false,
                type: 'multiple_choice'
            },

            /**
             * No Follow (multiple_choice)
             */
            seo__no_follow: {
                codename: 'seo__no_follow',
                id: 'f3bbb042-2cfa-4bf2-ad97-9a4756c45275',
                externalId: undefined,
                name: 'No Follow',
                required: false,
                type: 'multiple_choice'
            }
        }
    }
} as const;
